export default "/images/master24x24.svg?7c6d7b7a0191af806430db00dc3aa4ff";